<template>
  <b-modal id="createAgreementSlaModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreementsla.createAgreementSlaHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMAgreementSlaCreate :agreementIRI="agreementIRI"></EXCMAgreementSlaCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementSlaCreate from '../Create.vue'
export default {
  name: 'CreateAgreementSlaModal',
  components: {
    EXCMAgreementSlaCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreementsla.create.show
    },
    computedAgreementIRI () {
      return this.$store.state.modals.excmagreementsla.create.agreementIRI
    },
    close () {
      return this.$store.state.modals.excmagreementsla.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreementIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedAgreementIRI) {
        this.agreementIRI = this.$store.state.modals.excmagreementsla.create.agreementIRI
        this.$store.state.modals.excmagreementsla.create.show = 0
        this.$store.state.modals.excmagreementsla.create.agreementIRI = null
        this.$bvModal.show('createAgreementSlaModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreementsla.create.close = 0
        this.$bvModal.hide('createAgreementSlaModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
